<template>
  <div class="col-lg-12 nav-309">
    <div class="row align-items-center   py-2">
      <div class="col-lg-1 col-md-1  col-2  p-0 m-0">
        <button class="btn rounded-pill text-dark btn-light" data-toggle="modal"
                data-target="#nav-309-side-menu">
          <i class="bu bi-list"></i>
          <span v-t="`nav.menu_name`"></span>
        </button>
      </div>

      <div class="col-lg-5 col-md-5 p-0 col-9 d-none d-lg-block d-md-block d-sm-none">
        <m-search-input-1/>
      </div>

      <div class="col-2 d-lg-none d-md-none d-xl-none d-block">
        <m-search-input-2/>
      </div>

      <div class="col-lg-3 col-md-3   d-lg-block d-none">
        <m-menu1 :menuPosition="mainMenuPosition"/>
      </div>

      <div class="col-lg-2 col-md-2 col-4 p-0">
        <m-menu-4 :image="image" :show-panels="showPanels" :redirect="redirect">
          <slot name="menu-4"></slot>
          <template #classic-login-p-1-top>
            <slot name="classic-login-p-1-top"></slot>
          </template>
          <template #classic-login-p-1-bottom>
            <slot name="classic-login-p-1-bottom"></slot>
          </template>
          <template #two-step-login-p-1-top>
            <slot name="two-step-login-p-1-top"></slot>
          </template>
          <template #two-step-login-p-1-bottom>
            <slot name="two-step-login-p-1-bottom"></slot>
          </template>
        </m-menu-4>
      </div>
      <div class="col-lg-1 col-md-1  col-3  text-center">
        <m-a :href="{name:'Home'}">
          <img class="mx-auto nav309-inside-logo" :src="findAttributeOnSiteInfo('icon')[0]"
               :alt="findAttributeOnSiteInfo('site_name')[0]">
        </m-a>
      </div>
    </div>


    <div class="" dir="rtl">
      <div class="modal left fade" id="nav-309-side-menu" tabindex="-1" role="dialog">
        <div class="modal-dialog" role="document">
          <div class="modal-content">

            <div class="modal-header">
              <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span
                  aria-hidden="true">&times;</span>
              </button>
            </div>

            <div class="modal-body">
              <div class="text-center">
                <img :src="userAvatar" alt="user-profile" class="d-inline" height="35" width="35">
                <m-a :href="dashboardLink" v-if="isAuth" class="nav-link d-inline">
                  <button type="button" class="btn  d-inline btn-light btn-primary rounded-pill">{{
                      dashboardButtonText
                    }}
                  </button>
                </m-a>


                <m-modal-1 v-else class="d-inline-block" modal-size="modal-xl"
                           :modal-button-text="$t(dashboardButtonText)">
                  <m-login1 :image="image" :show-panels="showPanels" :redirect="redirect">
                    <template #classic-login-p-1-top>
                      <slot name="classic-login-p-1-top"></slot>
                    </template>
                    <template #classic-login-p-1-bottom>
                      <slot name="classic-login-p-1-bottom"></slot>
                    </template>
                    <template #two-step-login-p-1-top>
                      <slot name="two-step-login-p-1-top"></slot>
                    </template>
                    <template #two-step-login-p-1-bottom>
                      <slot name="two-step-login-p-1-bottom"></slot>
                    </template>
                  </m-login1>
                </m-modal-1>

              </div>

              <div class="container nav-sidebar-309-wrapper">
                <m-menu-2 :menuPosition="sideMenuPosition"/>

                <div class="nav-309-footer-section">

                  <slot name="footer"></slot>

                </div>

              </div>
            </div>

          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import {mapGetters} from "vuex";
import mA from '../../Tags/A.vue'
import mMenu2 from '../../Menu/Menu2.vue'
import mMenu1 from '../../Menu/Menu1.vue'
import {userAvatar} from '@moeinmdn/mixitweb-front-modules/src/plugin/Modules/User'
import mMenu4 from "../../Menu/Menu4.vue";
import mModal1 from "../../Tool/Modal/Modal1.vue";
import mLogin1 from "../../Authentication/Login/Login1.vue";
import mSearchInput2 from "../../Search/Input/SearchInput2.vue";
import mSearchInput1 from "../../Search/Input/SearchInput1.vue";
import {loginProps} from "../../Authentication/Login/LoginProps";

export default {
  name: "Nav309",
  components: {mA, mMenu2, mMenu1, mMenu4, mModal1, mLogin1, mSearchInput2, mSearchInput1},
  props: {
    sideMenuPosition: {
      default: 'store_nav'
    },
    mainMenuPosition: {
      default: 'store_nav'
    },
    dashboardLink: {
      default: 'https://mixitweb.com'
    },
    AuthLink: {
      default: {name: 'Login'}
    },
    ...loginProps
  },
  data() {
    return {
      userAvatar
    }
  },
  computed: {
    ...mapGetters({
      isAuth: "User/isAuthenticated",
    }),
    dashboardButtonText() {
      if (!this.isAuth) {
        return this.$t('nav.dashboard_un_auth')
      }
      return this.$t('nav.dashboard_auth')
    }
  }
}
</script>

<style scoped>
.nav309-inside-logo {
  max-width: 100%;
  max-height: 80px;
  object-fit: contain;
}

.modal.left .modal-dialog,
.modal.right .modal-dialog {
  position: fixed;
  margin: auto;
  width: 320px;
  height: 100%;
  -webkit-transform: translate3d(0%, 0, 0);
  -ms-transform: translate3d(0%, 0, 0);
  -o-transform: translate3d(0%, 0, 0);
  transform: translate3d(0%, 0, 0);
}

.modal.left .modal-content,
.modal.right .modal-content {
  height: 100%;
  overflow-y: auto;
}

.modal.left .modal-body,
.modal.right .modal-body {
  padding: 15px 15px 80px;
}

.nav-309-footer-section {
  position: absolute;
  bottom: 10px;
}

.nav-309 :deep(.search-input-1) {
  border-radius: 30px;
  border: 1px solid;
  padding: 3px;
  width: 100% !important;
}


.nav-309 :deep(.search-input-1 form) {
  border-radius: 30px !important;
}

.nav-309 :deep(.search-input-1 form i) {
  padding: 0 10px;
}

.nav-309 .nav-sidebar-309-wrapper :deep(.base-menu-item-wrapper){
  display: block !important;
}


</style>